import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import { PlcChp } from "./types";

import Source from "./components/Source";
import SourceMetric from "./components/SourceMetric";


interface IProps {
  data: PlcChp;
}


const SourceChp: FunctionComponent<IProps> = memo(function SourceChp({
  data,
}) {
  const intl = useIntl();

  return <>
    <Source
      name={intl.formatMessage({
        id: "site__control__chp__name",
        defaultMessage: "Cogeneration",
      })}
      offline={!data}
      {...data}
    >
      {data && <>
      <SourceMetric
        secondary
        name={intl.formatMessage({
          id: "site__control__chp__output",
          defaultMessage: "Output",
        })}
        value={data.power}
        unit="%"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__chp__temperature",
          defaultMessage: "Temperature",
        })}
        value={data.metrics?.c_temperature}
        unit="°C"
      />
      </>}
    </Source>
  </>
}, isEqual);

export default SourceChp;
